export const namespaced = true
import keys from "../keys"

export const state = {
	items: [
	{
		title: "Retailers",
		url:{name:'manage-retailers' },
		// src:require('@/assets/drawer/new-shipment.svg'),
		// src_active:require('@/assets/drawer/new-shipment-active.svg'),
		is_active_tab:false,
		access_by:[keys.WAREHOUSE,keys.SUPER_ADMIN],
	},
	{
		title: "Wholesaler",
		url:{name:'manage-wholesaler' },
		// src:require('@/assets/drawer/overview.svg'),
		// src_active:require('@/assets/drawer/overview-active.svg'),
		is_active_tab:false,
		access_by:[keys.WAREHOUSE,keys.SUPER_ADMIN],
	},
	{
		title: "Subscription plans",
		url:{name:'manage-subscription-plans' },
		is_active_tab:false,
		access_by:[keys.WAREHOUSE,keys.SUPER_ADMIN],
	},
	{
		title: "User Subscriptions",
		url:{name:'user-subscriptions' },
		is_active_tab:false,
		access_by:[keys.WAREHOUSE,keys.SUPER_ADMIN],
	},
	{
		title: "Payouts",
		url:{name:'employee-payout-history' },
		is_active_tab:false,
		access_by:[keys.WAREHOUSE,keys.SUPER_ADMIN],
	},
	{
		title: "Team",
		url:{name:'manage-team' },
		is_active_tab:false,
		access_by:[keys.WAREHOUSE,keys.SUPER_ADMIN],
	},
	{
		title: "Line",
		url:{name:'manage-line' },
		is_active_tab:false,
		access_by:[keys.WAREHOUSE,keys.SUPER_ADMIN],
	},
	{
		title: "Warehouses",
		url:{name:'manage-warehouses' },
		is_active_tab:false,
		access_by:[keys.SUPER_ADMIN],
	},
	{
		title: 'Wholesaler offer Image',
		url:{name:'wholesaler-offer-image' },
		is_active_tab:false,
		access_by:[keys.WAREHOUSE,keys.SUPER_ADMIN],
	},
	{
		title: 'Retailer offer Image',
		url:{name:'retailer-offer-image' },
		is_active_tab:false,
		access_by:[keys.WAREHOUSE,keys.SUPER_ADMIN],
	},
	

	],
}

export const mutations = {
	SET_ACTIVE_TAB(state,index){
		localStorage.setItem("active-tab", index);

		for (let i=0; i<state.items.length; i++){
			state.items[i].is_active_tab=false;
		}
		if(index!=-1){
			/*setting adtive tab*/ 
			state.items[index].is_active_tab = true;
		}
	},
}

export const actions = {
	setActiveTab({commit}, index){
		commit('SET_ACTIVE_TAB', index)
	},
}
export const getters = {
	getDrawerItems:state=>{
		return state.items;
	},
}